import React from 'react'
import ReactDOM from 'react-dom';
import { takeEvery, call, put, select, takeLatest } from 'redux-saga/effects';
import qs from 'qs';

//Utils
import axios from '../../services/axios-client';
import cookies from '../../services/cookies';
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

import history from '../../services/history';

//Components
import Notification from '../../components/Notifications/Notifications';

import { ROUTER_URL } from '../../const/ROUTER_URL';
import { HTTP_METHOD } from '../../const/http/HTTP_METHOD';
import { HTTP_STATUS_CODE } from '../../const/http/HTTP_STATUS_CODE';

export function* getCompanyInfo() {
    const companyAPIKey = yield select(state => state.auth.companyKey);

    try {
        const response = yield axios.request({
            method: HTTP_METHOD.POST,
            url: 'api/company/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyAPIKey
            },
        });

        const tintColor = response.data.result.company.app_color;
        document.querySelector('body').style.setProperty('--tint-color', tintColor);
        const match = tintColor.match(/rgb\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)/);
        if (match !== null) {
            document.querySelector('body').style.setProperty('--tint-color-rgb', [
                parseInt(match[1]),
                parseInt(match[2]),
                parseInt(match[3])
            ]);
        } else {
            document.querySelector('body').style.setProperty('--tint-color-rgb', [
                parseInt(tintColor.substring(1, 3), 16),
                parseInt(tintColor.substring(3, 5), 16),
                parseInt(tintColor.substring(5, 7), 16)
            ]);
        }

        const { font } = response.data.result.company;
        if (font) {
            const fontStyle = document.createElement('style');
            fontStyle.appendChild(document.createTextNode(`@import url('${font.import}');\n#root_appybee_widget {\nfont-family: ${font.name}, sans-serif !important;\n}`));
            document.head.appendChild(fontStyle);
        }

        yield put(actions.getCompanyInfoSucceeded(response.data.result));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* getShop({ shopID }) {
    try {
        const { companyKey, userToken } = yield select(state => state.auth);
        const strictPath = yield select(state => state.widget.strictPath);

        const response = yield axios.request({
            data: qs.stringify({
                shop_id: shopID
            }),
            method: HTTP_METHOD.POST,
            url: '/api/company/shop/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken,
            },
        });
        yield put(actions.getShopSucceeded(response.data.result, response.data.result.shop.id));
        yield put(actions.getGroupFilterOptions(response.data.result.shop.id));
        cookies.set('shopId', response.data.result.shop.id.toString(), {
            path: strictPath ? window.location.pathname : '/',
            domain: window.location.hostname,
            secure: true,
            sameSite: true,
        });
        // yield call(history.push, '/shop');
    } catch (error) {
        yield put(actions.getShopFailed());
        history.push(ROUTER_URL.SHOPS);
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* getShopList() {
    try {
        const companyAPIKey = yield select(state => state.auth.companyKey);

        const response = yield axios.request({
            method: HTTP_METHOD.POST,
            url: '/api/company/shop/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyAPIKey
            },
        });
        yield put(actions.getShopListSucceeded(response.data.result));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* getLoyaltyInformation() {
    try {
        const companyAPIKey = yield select(state => state.auth.companyKey);
        const locale = yield select(state => state.locales.locale);

        const resp = yield axios.request({
            method: HTTP_METHOD.POST,
            url: '/api/company/loyalty/information/get',
            headers: {
                'company-api-key': companyAPIKey,
                'locale': locale
            }
        });

        const { data: { result: payload } } = resp;
        yield put(actions.getLoyaltyInformationSucceeded(payload));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* loadShopID() {
    const shopID = parseInt(cookies.get('shopId'));
    if (!shopID || isNaN(shopID)) {
        return;
    }

    yield put(actions.getShop(shopID));
    // yield call(history.push, '/shop');
}

export function* getGroupFilterOptions({ shopId }) {
    const companyApiKey = yield select(state => state.auth.companyKey);
    const data = new FormData();
    data.append('shop_id', shopId);

    try {
        const response = yield axios.request({
            method: HTTP_METHOD.POST,
            url: '/api/company/shop/filters/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyApiKey,
            },
            data,
        });

        yield put(actions.getGroupFilterOptionsSucceeded(response.data.result));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export function* getPromotions() {
    const companyApiKey = yield select((state) => state.auth.companyKey);
    const userAccessToken = yield select(state => state.auth.userToken);
    const locale = yield select(state => state.locales.locale);

    const headers = {
        'company-api-key': companyApiKey,
        locale,
    }

    if (userAccessToken) {
        headers['user-access-token'] = userAccessToken;
    }

    const request = () => axios.request({
        method: HTTP_METHOD.POST,
        url: `/api/company/get/promotions`,
        headers,
    });

    try {
        const response = yield call(request);

        if (response?.data?.code === HTTP_STATUS_CODE.OK) {
            yield put(actions.setPromotions(response?.data?.result?.promotions));
        }
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error} />,
            document.getElementById('notification')
        );
    }
}

export const watchCompanies = [
    takeEvery(actionTypes.GET_SELECTED_COMPANY_INFO, getCompanyInfo),
    takeLatest(actionTypes.GET_SHOP, getShop),
    takeEvery(actionTypes.GET_SHOP_LIST, getShopList),
    takeEvery(actionTypes.GET_LOYALTY_INFORMATION, getLoyaltyInformation),
    takeEvery(actionTypes.LOAD_SHOP_ID, loadShopID),
    takeEvery(actionTypes.GET_GROUP_FILTER_OPTIONS, getGroupFilterOptions),
    takeEvery(actionTypes.GET_PROMOTIONS, getPromotions),
];
